// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"742":"dababb6840904dc6","786":"97056bac648b6c21","896":"b6ff2e55f5d8f28b"}[chunkId] + ".js";
};